import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  riskScoreCellContent: {
    position: "absolute",
    top: 30
  }
});
